import { FocusableOption } from '@angular/cdk/a11y';
import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[phxFocusableItem]',
  exportAs: 'phxElement',
  host: {
    'focus': 'focus()',
    tabIndex: '-2',
  }
})
export class PhxFocusableItemDirective implements FocusableOption {
  constructor(public elementRef: ElementRef<HTMLElement>) {}

  @Input() skip?: boolean;

  focus(): void {
    this.elementRef.nativeElement.focus();
  }
}
